import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import BlogBox from './BlogBox';

const BlogSecTwo = ({ className }) => {
    const { t } = useTranslation();
  return (

    <section className={className}>
        <div className="shape-mockup bg-gradient-shape1 blog-bg-gradient1" data-bottom="20%" data-top="auto" data-right="0" data-left="auto"></div>
        <div className="container">
            <div className="row justify-content-between align-items-center">
                <div className="col-lg-6">
                    <div className="title-area">
                            <span className="sub-title style2" data-cue="slideInUp">{t('sections.blogSecTwo.sub_title','New & Blog')}</span>
                            <h2 className="sec-title" data-cue="slideInUp">{t('sections.blogSecTwo.title','Latest News and Insights')}</h2>
                        </div>
                </div>
                <div className="col-auto">
                    <div className="sec-btn" data-cue="slideInUp">
                        <Link to="/blog" className="ot-btn style-border">{t('sections.blogSecTwo.view_more','View More')}<i className="far fa-long-arrow-right ms-2"></i></Link>
                    </div>
                </div>
            </div>
            <div className="row gy-4 justify-content-center">
                <BlogBox className="col-md-6" limit={2} />
            </div>
        </div>
    </section>
  );
};

export default BlogSecTwo;